import { RouteConfig } from 'vue-router';

const PAGE_TITLE = '关于高考的问题，这里都有答案！';

const route: RouteConfig = {
  path: '/20200330GKBTW',
  name: 'GKBTW',
  component: () => import('./Home.vue'),

  meta: {
    title: PAGE_TITLE,
  },
};

export default route;
